import { render, staticRenderFns } from "./PrivateLogin.vue?vue&type=template&id=1de46e44&scoped=true"
import script from "./PrivateLogin.vue?vue&type=script&lang=js"
export * from "./PrivateLogin.vue?vue&type=script&lang=js"
import style0 from "./PrivateLogin.vue?vue&type=style&index=0&id=1de46e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de46e44",
  null
  
)

export default component.exports